import "./sentry"
import "./styles/index.css"
import { app } from "./App"

void app.init()
